import { Injectable } from "@angular/core";
import { LoginResponse, CreateOrEditQuestionDto } from "../service-proxies";
import { DBkeys } from "./db-keys";
import { Observable, Subject } from "rxjs";
import { Router, NavigationExtras } from "@angular/router";
import { LocalStoreManager } from "./local-store-manager.service";
import { Utilities } from "./utilities";

@Injectable({
    providedIn:'root'
})
export class AuthService {
    private loginUrl = '/accounts/login';
    public loginRedirectUrl: string;
    public logoutRedirectUrl: string;

    public reLoginDelegate: () => void;

    private previousIsLoggedInCheck = false;
    private _loginStatus = new Subject<boolean>();

    constructor(
        private router: Router,
        private localStorage: LocalStoreManager) {

        this.initializeLoginStatus();
    }

    private initializeLoginStatus() {
        this.localStorage.getInitEvent().subscribe(() => {
            this.reevaluateLoginStatus();
        });
    }

    gotoPage(page: string, preserveParams = true) {

        const navigationExtras: NavigationExtras = {
            queryParamsHandling: preserveParams ? 'merge' : '', preserveFragment: preserveParams
        };

        this.router.navigate([page], navigationExtras);
    }

    gotoHomePage() {
        this.router.navigate(['/']);
    }

    redirectLoginUser() {
        // const redirect = this.loginRedirectUrl && this.loginRedirectUrl != '/' && this.loginRedirectUrl != ConfigurationService.defaultHomeUrl ? this.loginRedirectUrl : this.homeUrl;
        const redirect = '/';
        this.loginRedirectUrl = null;

        const urlParamsAndFragment = Utilities.splitInTwo(redirect, '#');
        const urlAndParams = Utilities.splitInTwo(urlParamsAndFragment.firstPart, '?');

        const navigationExtras: NavigationExtras = {
            fragment: urlParamsAndFragment.secondPart,
            queryParams: Utilities.getQueryParamsFromString(urlAndParams.secondPart),
            queryParamsHandling: 'merge'
        };

        this.router.navigate([urlAndParams.firstPart], navigationExtras);
    }

    redirectLogoutUser() {
        const redirect = this.logoutRedirectUrl ? this.logoutRedirectUrl : this.loginUrl;
        this.logoutRedirectUrl = null;

        this.router.navigate([redirect]);
    }

    redirectForLogin() {
        this.loginRedirectUrl = this.router.url;
        this.router.navigate([this.loginUrl]);
    }

    reLogin() {
        if (this.reLoginDelegate) {
            this.reLoginDelegate();
        } else {
            this.redirectForLogin();
        }
    }

    // refreshLogin() {
    //     return this.oidcHelperService.refreshLogin()
    //         .pipe(map(resp => this.processLoginResponse(resp, this.rememberMe)));
    // }

    // loginWithPassword(userName: string, password: string, rememberMe?: boolean) {
    //     if (this.isLoggedIn) {
    //         this.logout();
    //     }

    //     return this.oidcHelperService.loginWithPassword(userName, password)
    //         .pipe(map(resp => this.processLoginResponse(resp, rememberMe)));
    // }

 public processLoginResponse(response: LoginResponse, rememberMe?: boolean): void {
     debugger;
        const accessToken = response.token;

        if (accessToken == null) {
            throw new Error('accessToken cannot be null');
        }

        const user  = response;

        this.saveUserDetails(user, accessToken, true);

        this.reevaluateLoginStatus(user);

        // return user;
    }

    private saveUserDetails(user: LoginResponse, accessToken: string, rememberMe: boolean) {
        if (rememberMe) {
            this.localStorage.savePermanentData(accessToken, DBkeys.ACCESS_TOKEN);
            // this.localStorage.savePermanentData(refreshToken, DBkeys.REFRESH_TOKEN);
            // this.localStorage.savePermanentData(expiresIn, DBkeys.TOKEN_EXPIRES_IN);
            // this.localStorage.savePermanentData(permissions, DBkeys.USER_PERMISSIONS);
            this.localStorage.savePermanentData(user, DBkeys.CURRENT_USER);
        } else {
            this.localStorage.saveSyncedSessionData(accessToken, DBkeys.ACCESS_TOKEN);
            // this.localStorage.saveSyncedSessionData(refreshToken, DBkeys.REFRESH_TOKEN);
            // this.localStorage.saveSyncedSessionData(expiresIn, DBkeys.TOKEN_EXPIRES_IN);
            // this.localStorage.saveSyncedSessionData(permissions, DBkeys.USER_PERMISSIONS);
            this.localStorage.saveSyncedSessionData(user, DBkeys.CURRENT_USER);
        }

        this.localStorage.savePermanentData(rememberMe, DBkeys.REMEMBER_ME);
    }

    public saveGuestQuestion(question: CreateOrEditQuestionDto) {
        this.localStorage.savePermanentData(question, DBkeys.guestQuestion);
        
    }
    public getsaveGuestQuestion(): any
    {
        return this.localStorage.getData(DBkeys.guestQuestion);
    }

    public removeGuestQuestion() {
        this.localStorage.deleteData(DBkeys.guestQuestion);
    }

    logout(): void {
        this.localStorage.deleteData(DBkeys.ACCESS_TOKEN);
        // this.localStorage.deleteData(DBkeys.REFRESH_TOKEN);
        // this.localStorage.deleteData(DBkeys.TOKEN_EXPIRES_IN);
        // this.localStorage.deleteData(DBkeys.USER_PERMISSIONS);
        this.localStorage.deleteData(DBkeys.CURRENT_USER);

        // this.configurations.clearLocalChanges();

        this.router.navigate(['/']);
        this.reevaluateLoginStatus();
        setTimeout(() => {
            window.location.reload();
        }, 500);
    }

    private reevaluateLoginStatus(currentUser?: LoginResponse) {
        
        const user = currentUser || this.localStorage.getDataObject<LoginResponse>(DBkeys.CURRENT_USER);
        const isLoggedIn = user != null;

        if (this.previousIsLoggedInCheck != isLoggedIn) {
            setTimeout(() => {
                this._loginStatus.next(isLoggedIn);
            });
        }

        this.previousIsLoggedInCheck = isLoggedIn;
    }

    getLoginStatusEvent(): Observable<boolean> {
        return this._loginStatus.asObservable();
    }

    get guestQuestion(): CreateOrEditQuestionDto {
        const question = this.localStorage.getDataObject<CreateOrEditQuestionDto>(DBkeys.guestQuestion);
        return question ? question : null;
    }

    get userRole(): string {
        const user = this.localStorage.getDataObject<LoginResponse>(DBkeys.CURRENT_USER);
        this.reevaluateLoginStatus(user);

        return user.role ? user.role : '';
    }

    get userId(): string {
        const user = this.localStorage.getDataObject<LoginResponse>(DBkeys.CURRENT_USER);
        this.reevaluateLoginStatus(user);
        return user.userId ? user.userId : '';
    }

    get userNumberId(): number {
        const user = this.localStorage.getDataObject<LoginResponse>(DBkeys.CURRENT_USER);
        this.reevaluateLoginStatus(user);
        return user.autoUserId ? user.autoUserId : 0;
    }

    get currentUser(): LoginResponse {

        const user = this.localStorage.getDataObject<LoginResponse>(DBkeys.CURRENT_USER);
        this.reevaluateLoginStatus(user);

        return user;
    }

    get currentUserName(): string {

        const user = this.localStorage.getDataObject<LoginResponse>(DBkeys.CURRENT_USER);
        this.reevaluateLoginStatus(user);

        return user.userName;
    }

    // get userPermissions(): PermissionValues[] {
    //     return this.localStorage.getDataObject<PermissionValues[]>(DBkeys.USER_PERMISSIONS) || [];
    // }

    // get accessToken(): string {
    //     return this.oidcHelperService.accessToken;
    // }

    // get accessTokenExpiryDate(): Date {
    //     return this.oidcHelperService.accessTokenExpiryDate;
    // }

    // get refreshToken(): string {
    //     return this.oidcHelperService.refreshToken;
    // }

    // get isSessionExpired(): boolean {
    //     return this.oidcHelperService.isSessionExpired;
    // }

    get isLoggedIn(): boolean {
        return this.currentUser != null;
    }

    // get rememberMe(): boolean {
    //     return this.localStorage.getDataObject<boolean>(DBkeys.REMEMBER_ME) == true;
    // }

    setLanguage(lang: string) {
        this.saveLanguage(lang);
    }

    private saveLanguage(lang: string) {
        this.localStorage.savePermanentData(lang,DBkeys.LANGUAGE);
    }
    
    get CurrentLanguage(): string {
        const lang = this.localStorage.getDataObject<string>(DBkeys.LANGUAGE);
        if (lang) {
            return lang;
        }
        return 'en';
    }
}